<template>
  <v-snackbar
    :model-value="modelValue"
    class="ocr-app-snackbar"
    :class="`ocr-app-snackbar--${resolvedKey}`"
    :color="resolvedColor"
    :timeout="timeout"
    location="bottom"
    multi-line
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="ocr-snackbar-body">
      <v-icon :icon="resolvedIcon" size="20" class="ocr-snackbar-icon" />
      <span class="ocr-snackbar-text">{{ message }}</span>
    </div>
    <template #actions>
      <v-btn
        variant="text"
        density="compact"
        icon="mdi-close"
        class="ocr-snackbar-close"
        aria-label="Dismiss notification"
        @click="$emit('update:modelValue', false)"
      />
    </template>
  </v-snackbar>
</template>

<script>
const VARIANTS = {
  success: { color: "#22C55E", icon: "mdi-check-circle-outline" },
  error: { color: "#E53535", icon: "mdi-alert-circle-outline" },
  danger: { color: "#E53535", icon: "mdi-alert-circle-outline" },
  warning: { color: "#F59E0B", icon: "mdi-alert-outline" },
  info: { color: "#1E3A5F", icon: "mdi-information-outline" },
};

export default {
  name: "OcrSnackbar",
  props: {
    modelValue: { type: Boolean, default: false },
    message: { type: String, default: "" },
    variant: { type: String, default: "info" },
    timeout: { type: Number, default: 4000 },
  },
  emits: ["update:modelValue"],
  computed: {
    resolvedKey() {
      const key = String(this.variant || "info").toLowerCase();
      return VARIANTS[key] ? key : "info";
    },
    resolved() {
      return VARIANTS[this.resolvedKey] || VARIANTS.info;
    },
    resolvedColor() {
      return this.resolved.color;
    },
    resolvedIcon() {
      return this.resolved.icon;
    },
  },
};
</script>
